<template>
  <v-main v-resize="onResize" ref="content" class="pt-0">
    <v-container fluid>
      <v-row class="search-condition">
        <page-title />
        <v-col cols="12">
          <v-card class="d-flex pa-1 bg mb-1" height="39" outlined>
            <span>
              <time-navigator v-model="datetime" :increment="1" :active-increment.sync="activeIncrement" :backward="[30, 300]" :forward="[30, 300]"></time-navigator>
            </span>
          </v-card>
        </v-col>
      </v-row>
      <v-row style="height: calc(100% - 76px)">
        <v-col>
          <v-row class="h-35">
            <v-col cols="6"><dump-chart :sstm-id="systemId" :store-name="storeName" :datetime="datetime" :active-increment="activeIncrement"/></v-col>
            <v-col cols="6"><dump-grid :params="gridParams" :timestamp="timestamp" :clickRow="getDumpMessage" :onFetch="removeDumpMessage"/></v-col>
          </v-row>
          <v-row class="h-65">
            <v-col cols="3">
              <!-- <v-card class="card-wrap" :height="lowerCardHeight"> -->
              <v-card class="card-wrap h-100">
                <v-card-title>Message category</v-card-title>
                <div class="box">
                  <v-list>
                    <v-list-item-group>
                      <v-list-item v-for="(msg, i) in dumpMsgs" :key="i" active-class="primary-color" :href="`#${msg.category}`">
                        <v-list-item-content>
                          <v-list-item-title>{{ msg.category }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </div>
              </v-card>
            </v-col>
            <v-col cols="9">
              <!-- <v-card class="card-wrap" :height="lowerCardHeight"> -->
              <v-card class="card-wrap h-100">
                <v-card-title>Message detail</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="3"><p class="label">Category</p></v-col>
                        <v-col cols="9"><v-text-field :value="dumpData.category" outlined dense hide-details readonly></v-text-field></v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="3"><p class="label">Runtime Errors</p></v-col>
                        <v-col cols="9"><v-text-field :value="dumpData.dumpId" outlined dense hide-details readonly></v-text-field></v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="3"><p class="label">Except.</p></v-col>
                        <v-col cols="9"><v-text-field :value="dumpData.exNm" outlined dense hide-details readonly></v-text-field></v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="3"><p class="label">Date and Time</p></v-col>
                        <v-col cols="9"><v-text-field :value="dumpData.sapYmdhms | format('yyyy-MM-dd HH:mm:ss')" outlined dense hide-details readonly></v-text-field></v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
                <div class="card-inner-div" :style="forceHeight">
                  <v-expansion-panels :value="panel" accordion multiple hover tile readonly>
                    <v-expansion-panel v-for="(msg, i) in dumpMsgs" :key="i">
                      <v-expansion-panel-header :id="msg.category" hide-actions>{{ msg.category }}</v-expansion-panel-header>
                      <v-expansion-panel-content v-html="msg.content"></v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { api } from '../../../../api/common/instances';
import bus from '../../../../utils/bus';
import DumpChart from './chart/Dump';
import DumpGrid from './grid/Dump';
import referable from '../../components/referable';

export default {
  components: {
    DumpChart,
    DumpGrid,
  },
  mixins: [referable],
  data() {
    return {
      storeName: 'detailview/abap/dump',
      datetime: new Date(),
      activeIncrement: true,
      height: 0,
      timestamp: 0,
      dumpData: {},
      dumpMsgs: [],
      panel: [],
      lowerCardHeight: 0,
    };
  },
  watch: {
    systemId: {
      immediate: true,
      handler() {
        this.referer();
        if (this.activeIncrement) {
          this.$websocket.realtime.connect();
        }
      },
    },
    activeIncrement: {
      handler(value) {
        if (value) {
          this.datetime = new Date();
          this.$websocket.realtime.connect();
        } else {
          this.$websocket.realtime.close();
        }
      },
    },
  },
  computed: {
    systemId() {
      return this.$route.params.systemId;
    },
    gridParams() {
      return {
        sstmId: this.systemId,
        height: this.height,
      };
    },
    forceHeight() {
      return `height: ${this.lowerCardHeight - 120}px`;
    },
  },
  methods: {
    setActiveIncrement(active) {
      this.activeIncrement = active;
    },
    onResize() {
      const height = window.innerHeight - 160;
      this.height = height - height * 0.65 - 56;
      this.lowerCardHeight = height - height * 0.35 - 20;
    },
    // BEGIN::Added.by.2023.06.21.KWShin.
    // Grid 내역 재조회가 발생하면 하단 상세 메시지를 제거해준다.
    removeDumpMessage() {
      this.dumpData = {};
      this.dumpMsgs = [];
    },
    // FINISH::Added.by.2023.06.21.KWShin.
    async getDumpMessage(item) {
      const { data } = await api.get('/detailview/abapdump/message', {
        params: {
          svrYmdhms: item.svrYmdhms,
          sapYmdhms: item.sapYmdhms,
          sstmId: item.sstmId,
          ahost: item.ahost,
          dumpId: item.dumpId,
          modno: item.modno,
        },
      });
      this.dumpData = data;
      this.dumpMsgs = data.parsedMessage;
      this.panel = this.dumpMsgs.reduce((acc, elm, idx) => {
        acc.push(idx);
        return acc;
      }, []);
    },
    addEventListener() {
      bus.$on(`change:timestamp-${this.storeName}`, ({ timestamp }) => (this.timestamp = timestamp));
      bus.$on(`set:active-increment-${this.storeName}`, active => (this.activeIncrement = active));
    },
    removeEventListener() {
      bus.$off(`change:timestamp-${this.storeName}`);
      bus.$off(`set:active-increment-${this.storeName}`);
    },
  },
  created() {
    this.addEventListener();
  },
  destroy() {
    this.removeEventListener();
    this.$websocket.realtime.close();
  },
};
</script>

<style scoped>
.search-condition {
  margin-bottom: -6.5px;
}
.card-inner-div {
  overflow: auto;
}
.v-list {
  padding: 0;
  min-height: 32px;
}
.v-list-item {
  min-height: 32px;
}
.v-list-item__content {
  padding: 0;
}
.v-expansion-panel-content {
  padding-left: 20px;
}
.label {
  text-align: right;
  padding-right: 15px;
}
.v-text-field {
  width: 100%;
}
</style>
